<template>
    <div class="categories_item">
      <NuxtLink :to="`/category/${category.id}/${slugify(category.name)}`" class="category_item">
        <!-- @mouseenter="isHovered = true"
      @mouseleave="isHovered = false" 
          :src="isHovered ? category.dark_icon : category.icon"
      -->
        <div class="cate-title">
          <span class="mini_icon">

            <NuxtImg
              :src="category.icon"
              :alt="category.name"
              loading="lazy"
              :custom="true"
              v-slot="{ src, isLoaded, imgAttrs }"
            >
              <!-- Show the actual image when loaded -->
              <img
                v-if="isLoaded"
                v-bind="imgAttrs"
                :src="src"
              >

              <!-- Show a placeholder while loading -->
              <img
                v-else
                :src="'/website/assets/img/default-featured-image.jpeg'"
              >
            </NuxtImg>


            <!-- <img :src="category.icon" :alt="category.name" /> -->
          </span>
          <h1>{{ category.name }}</h1>
        </div>
        <div class="cate-arrow">
          
          <svg xmlns="http://www.w3.org/2000/svg" width="7.272" height="12.136" viewBox="0 0 7.272 12.136"><g id="Group_55448" data-name="Group 55448" transform="translate(7.272 12.136) rotate(180)"><g id="previous" transform="translate(7.272 12.136) rotate(180)"><path id="Path_38383" data-name="Path 38383" d="M.342,5.206a1.186,1.186,0,0,1,.2-.158l4.7-4.7A1.176,1.176,0,0,1,6.907,2.007L2.856,6.057l4.072,4.072a1.175,1.175,0,1,1-1.662,1.662L.541,7.067a1.22,1.22,0,0,1-.2-1.861Z" transform="translate(0 0)" fill="#d0d5dc"></path></g></g></svg>
        </div>
      </NuxtLink>
    </div>
  </template>
  
  <script setup lang="ts">

  import { ref, onMounted } from 'vue'

  const isHovered = ref(false)


  onMounted(() => {
    const boxes = document.querySelectorAll('.category_item');
    boxes.forEach((box, index) => {
      setTimeout(() => {
        box.classList.add('visible');
      }, index * 50); // Delay increases for each box
    });
  });


  defineProps({
    category: Object
  });

  const slugify = (text: string): string =>
  text.trim().replace(/\s+/g, '-').toLowerCase()

  </script>